import { render, staticRenderFns } from "./ConsumerEntry.vue?vue&type=template&id=024b155b&scoped=true&"
import script from "./ConsumerEntry.vue?vue&type=script&lang=js&"
export * from "./ConsumerEntry.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerEntry.vue?vue&type=style&index=0&id=024b155b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b155b",
  null
  
)

export default component.exports